import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/IAppState';

const excelConnectorSelector = (state: IAppState) => state.excelConnector;

export const getExcelConnectors = createSelector(
    excelConnectorSelector,
    (state: IExcelConnectorState) => state.excelConnectorList.connectors
);

export const getExcelConnectorViewStatus = createSelector(
    excelConnectorSelector,
    (state: IExcelConnectorState) => state.excelConnectorList.viewStatus
);

export const getIsLoadingConnectorsList = createSelector(
    excelConnectorSelector,
    (state: IExcelConnectorState) => state.excelConnectorList.isLoading
);
